module.exports = __webpack_public_path__ + "assets/img/user.412217ec.png";